import { render, staticRenderFns } from "./ZoneUsers.vue?vue&type=template&id=198e32ca&"
import script from "./ZoneUsers.vue?vue&type=script&lang=js&"
export * from "./ZoneUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports